import React from 'react';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { GeneralButton } from "../../../../../../CommonComponents/Commons/commonComponents";
import history from "../../../../../../history/history";
import {Content, DividerComponent, MainHeading,
          Displayflex, DisplayflexMain } from './styles';
import {ContribType, TransactionId} from "../ReviewContributionAndSubmit/Components/ContributionType/styles";
import FundingInst from "./Components/LOADocs/FundingInstructions" ;
import Popup from "../ContributionType/Components/Popup/Popup";
import WiringInstructions from "./Components/WiringInstructions/WiringInstructions";
import { recordError } from "../../../../../../utils/commonUtil";
import { fundingInstructionsState } from '../../selectors';
let popUpState = false; 
let wiringPopUp = false; 

class FundingInstructions extends React.Component {

        constructor(props) {
            super(props);
            this.state = {show: false, wiringState: false };
        }

        handleNext() {
          try {
            history.push("/contributions/make-a-contribution/confirmation");
            window.scrollTo(0, 0);
          } catch (error) {
            recordError(error);
          }
        }

        closeModal = () => {
            popUpState = false;
            this.setState({
              show: false
            });
          };
    
        removePopupContent = {
            heading: "Remove Information",
            line1: "Are you sure you want to remove information?",
            line2: "Do you want to continue?",
            continue: "continue",
            cancel: "No, take me back",
            type: "removeInfo"
          };

        onExitClick = () => {
            popUpState = true;
            this.setState({
              show: true
            });
        }

        showWiringInstructions = () => {
          wiringPopUp = true;
          this.setState({wiringState: true});
      }

      handleOkay = () => {
        document.body.style.overflow = "";
        this.setState({
          wiringState: true
        });
        wiringPopUp = false;
      };

      onRemoveClick = () => {
        document.body.style.overflow = "";
        history.push("/contributions");
      }
    
        render() {
         const transactionId = (this.props.data && this.props.data.transactionId) ? this.props.data.transactionId : '';
    return(
        <div>
             {popUpState === true ? (
            <Popup
              width="481px"
              mwidth="88%"
              content={this.removePopupContent}
              closeModal={this.closeModal}
              handleRemove={() => this.onRemoveClick()}
            />
          ) : null }
          { wiringPopUp === true ? (
    <WiringInstructions handleOkay={this.handleOkay} />
  ) : null}
            <ContribType>Transaction Id :</ContribType><TransactionId>{transactionId}</TransactionId>
            <MainHeading marginBottom="15px" marginTop="20px" mB='5px'>Funding Instructions</MainHeading>
            <Content marginBottom="50px" mB='40px'>Please follow the instructions carefully to ensure your contribution is processed. Your contribution will not be processed until the following requirements are met:</Content>
            <FundingInst />
            <Content>Once you have printed all required instructions and forms, click Next to proceed to the confirmation screen.</Content>
      
            <DividerComponent/>
            <DisplayflexMain>
            <Displayflex>
            
            </Displayflex>
            <GeneralButton 
              id="btnNext"
              text = "Next"
              width = "150px"
              mobWidth = "100%"
              styling= "mb3"
              onClick={() => this.handleNext()}
            />
            </DisplayflexMain>
        </div>
    )
}
}

FundingInstructions.propTypes = {
  data: PropTypes.object,
}

const mapStateToProps = state => ({
  ...fundingInstructionsState(state.toJS())
});

export default withRouter(connect(mapStateToProps, null)(FundingInstructions));